/* tslint:disable */
/* eslint-disable */
/* @relayHash ed703c8b1165866cd2b156ee1429545e */

import { ConcreteRequest } from "relay-runtime";
export type ResetPassword_ResetMutationVariables = {
    token: string;
    password: string;
};
export type ResetPassword_ResetMutationResponse = {
    readonly resetPassword: {
        readonly token: string;
    } | null;
};
export type ResetPassword_ResetMutation = {
    readonly response: ResetPassword_ResetMutationResponse;
    readonly variables: ResetPassword_ResetMutationVariables;
};



/*
mutation ResetPassword_ResetMutation(
  $token: String!
  $password: String!
) {
  resetPassword(input: {token: $token, password: $password}) {
    token
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "token",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "password",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "resetPassword",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "password",
                            "variableName": "password"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ]
                }
            ],
            "concreteType": "AuthToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "token",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ResetPassword_ResetMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "ResetPassword_ResetMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "ResetPassword_ResetMutation",
            "id": null,
            "text": "mutation ResetPassword_ResetMutation(\n  $token: String!\n  $password: String!\n) {\n  resetPassword(input: {token: $token, password: $password}) {\n    token\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '962025c3a130629a8e2f7fbeb667ba08';
export default node;
